var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5159 13.0332C10.3304 13.0332 8.39591 10.7499 8.39591 8.51664V7.83324C8.43547 6.7791 8.89136 5.78365 9.66366 5.06509C10.436 4.34653 11.4617 3.96349 12.5159 3.99994C13.5702 3.96349 14.5959 4.34653 15.3682 5.06509C16.1405 5.78365 16.5964 6.7791 16.6359 7.83324V8.51664C16.636 10.7499 14.7013 13.0332 12.5159 13.0332ZM19.8067 19.9999H5.22511C5.11551 20.0022 5.00931 19.9618 4.92904 19.8871C4.84877 19.8124 4.80073 19.7094 4.79511 19.5999V17.9332C4.78405 17.2631 4.98393 16.6065 5.36649 16.0562C5.74904 15.5059 6.29492 15.0897 6.92691 14.8666C8.71903 14.2475 10.602 13.9321 12.498 13.9332C14.3934 13.9403 16.275 14.2555 18.0691 14.8666C18.7011 15.0897 19.247 15.5059 19.6295 16.0562C20.012 16.6065 20.2119 17.2631 20.2008 17.9332V19.5999C20.2053 19.6531 20.1982 19.7066 20.18 19.7567C20.1619 19.8069 20.1331 19.8525 20.0957 19.8905C20.0582 19.9285 20.013 19.9579 19.9632 19.9768C19.9133 19.9957 19.8599 20.0036 19.8067 19.9999Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_20037",
    x1: 15.8685,
    y1: 4.7977,
    x2: 12.0506,
    y2: 19.8875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.fa211106b79b9d06363f2af81c651435.svg";
export { ForwardRef as ReactComponent };